<template>
  <div>
    <v-card outlined :loading="loading" class="mb-3">
      <v-card-text class="text-center">
        <div class="text-subtitle-2 grey--text">{{ $t('message.flex.balance') }}</div>
        <div class="text-h4 my-2" :class="balanceColor">
          {{ $formatter.formatFlexMinutes(balance.balance_minutes) }}
        </div>
        <div v-if="balance.policy_name" class="text-caption grey--text">
          {{ $t('message.flex.policy') }}: {{ balance.policy_name }}
        </div>
        <div v-if="balance.as_of" class="text-caption grey--text">
          {{ $t('message.flex.asOf') }}: {{ $formatter.formatDate(balance.as_of, '', 'DD.MM.YYYY HH:mm') }}
        </div>
      </v-card-text>
    </v-card>

    <v-card outlined>
      <v-card-title class="text-subtitle-1">{{ $t('message.flex.transactions') }}</v-card-title>
      <v-divider></v-divider>
      <v-list v-if="recentTransactions.length" two-line dense>
        <v-list-item v-for="tx in recentTransactions" :key="tx.id">
          <v-list-item-content>
            <v-list-item-title>{{ txTypeLabel(tx.type) }}</v-list-item-title>
            <v-list-item-subtitle>{{ $formatter.formatDate(tx.date, 'YYYY-MM-DD', 'DD.MM.YYYY') }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <span :class="tx.delta_minutes >= 0 ? 'success--text' : 'error--text'">
              {{ $formatter.formatFlexMinutes(tx.delta_minutes) }}
            </span>
          </v-list-item-action>
        </v-list-item>
      </v-list>
      <v-card-text v-else class="grey--text">{{ $t('message.flex.noTransactions') }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" :to="{ name: 'flex-transactions' }">
          {{ $t('message.flex.transactionHistory') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'FlexBalance',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('flexAccount', ['getFlexBalance', 'getFlexTransactions']),
    balance () {
      return this.getFlexBalance
    },
    balanceColor () {
      const minutes = this.balance.balance_minutes
      if (minutes > 0) return 'success--text'
      if (minutes < 0) return 'error--text'
      return ''
    },
    recentTransactions () {
      return this.getFlexTransactions.slice(0, 5)
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('flexAccount', ['GET_FLEX_BALANCE', 'GET_FLEX_TRANSACTIONS']),
    loadData () {
      this.loading = true
      Promise.all([this.GET_FLEX_BALANCE(), this.GET_FLEX_TRANSACTIONS()])
        .catch(() => {
          this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: 'message.common.errorOccured' })
        })
        .finally(() => {
          this.loading = false
        })
    },
    txTypeLabel (type) {
      const key = `message.flex.txType.${type}`
      const label = this.$t(key)
      return label === key ? type : label
    }
  }
}
</script>
